import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Globe, Mail, MapPin, Phone, MessageCircle } from "lucide-react";
import Logo from "./Logo";
import { APPS, CONTACT } from "../data/apps";
import { API } from "../lib/api";

export const Footer = () => {
  const [privacyUrl, setPrivacyUrl] = useState("");
  useEffect(() => {
    axios.get(`${API}/settings`).then((r) => setPrivacyUrl(r.data.privacy_url || "")).catch(() => {});
  }, []);

  return (
    <footer data-testid="main-footer" className="bg-navy text-white">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-16 pb-10">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <Logo className="h-9 w-9" light />
              <span className="font-display font-bold text-lg tracking-tight">TIRERA GROUP</span>
            </Link>
            <p className="text-sm text-white/60 leading-relaxed max-w-xs">
              Un écosystème numérique malien qui réunit toutes nos applications sur une seule plateforme.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/50 mb-4">Nos activités</h4>
            <ul className="space-y-2.5">
              {APPS.map((a) => (
                <li key={a.slug}>
                  <Link
                    to={`/applications/${a.slug}`}
                    data-testid={`footer-app-${a.slug}`}
                    className="text-sm text-white/80 hover:text-white transition-colors"
                  >
                    {a.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/50 mb-4">Entreprise</h4>
            <ul className="space-y-2.5">
              <li><Link to="/a-propos" className="text-sm text-white/80 hover:text-white transition-colors">À propos</Link></li>
              <li><Link to="/contact" className="text-sm text-white/80 hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/locataire" data-testid="footer-tenant-space" className="text-sm text-white/80 hover:text-white transition-colors">Espace locataire</Link></li>
              <li>
                {privacyUrl ? (
                  <a href={privacyUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-privacy" className="text-sm text-white/80 hover:text-white transition-colors">Politique de confidentialité</a>
                ) : (
                  <Link to="/confidentialite" data-testid="footer-privacy" className="text-sm text-white/80 hover:text-white transition-colors">Politique de confidentialité</Link>
                )}
              </li>
              <li><Link to="/conditions" data-testid="footer-terms" className="text-sm text-white/80 hover:text-white transition-colors">Conditions d'utilisation</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/50 mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-sm text-white/80"><Globe size={16} className="text-white/40" />{CONTACT.site}</li>
              <li className="flex items-center gap-3 text-sm text-white/80"><Mail size={16} className="text-white/40" />{CONTACT.email}</li>
              <li className="flex items-center gap-3 text-sm text-white/80"><Phone size={16} className="text-white/40" />{CONTACT.phone}</li>
              <li>
                <a href={CONTACT.whatsappLink} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 text-sm text-white/80 hover:text-white transition-colors">
                  <MessageCircle size={16} className="text-[#25D366]" />WhatsApp : {CONTACT.whatsapp}
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-white/80"><MapPin size={16} className="text-white/40" />{CONTACT.address}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col gap-3">
          <p className="text-xs text-white/50 leading-relaxed">
            {CONTACT.company} · RCCM {CONTACT.rccm} · NINA {CONTACT.nina} · Siège : {CONTACT.registeredOffice}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-white/50">© {new Date().getFullYear()} {CONTACT.company}. Tous droits réservés.</p>
            <p className="text-xs text-white/50">Bamako, Mali 🇲🇱</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
